import { Sun, Moon, Accessibility, Type, Plus, Minus, RotateCcw } from 'lucide-react';
import { useTheme, Theme } from '@/contexts/ThemeContext';
import { Button } from '@/components/ui/button';
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuLabel,
  DropdownMenuSeparator,
  DropdownMenuTrigger,
} from '@/components/ui/dropdown-menu';
import { cn } from '@/lib/utils';

export const ThemeToggle = () => {
  const { theme, setTheme, increaseFontSize, decreaseFontSize, resetFontSize } = useTheme();

  const themes: { value: Theme; label: string; icon: any }[] = [
    { value: 'light', label: 'Modo Claro', icon: Sun },
    { value: 'dark', label: 'Modo Escuro', icon: Moon },
    { value: 'high-contrast', label: 'Alto Contraste', icon: Accessibility },
  ];

  const CurrentIcon = themes.find(t => t.value === theme)?.icon || Sun;

  return (
    <div className="flex items-center gap-2">
      {/* Font Size Controls */}
      <div className="flex items-center bg-muted rounded-lg p-1 mr-2">
        <Button 
          variant="ghost" 
          size="icon" 
          className="h-8 w-8" 
          onClick={decreaseFontSize}
          aria-label="Diminuir tamanho da fonte"
        >
          <Minus className="h-4 w-4" />
        </Button>
        <div className="px-2 text-xs font-bold flex items-center gap-1" aria-hidden="true">
          <Type className="h-3 w-3" />
        </div>
        <Button 
          variant="ghost" 
          size="icon" 
          className="h-8 w-8" 
          onClick={increaseFontSize}
          aria-label="Aumentar tamanho da fonte"
        >
          <Plus className="h-4 w-4" />
        </Button>
      </div>

      {/* Theme Selector */}
      <DropdownMenu>
        <DropdownMenuTrigger asChild>
          <Button variant="outline" size="icon" className="h-9 w-9 rounded-full" aria-label="Alterar tema e acessibilidade">
            <CurrentIcon className="h-[1.2rem] w-[1.2rem]" />
          </Button>
        </DropdownMenuTrigger>
        <DropdownMenuContent align="end" className="w-56">
          <DropdownMenuLabel>Temas</DropdownMenuLabel>
          {themes.map((t) => (
            <DropdownMenuItem 
              key={t.value} 
              onClick={() => setTheme(t.value)}
              className={cn("flex items-center gap-2 cursor-pointer", theme === t.value && "bg-accent")}
            >
              <t.icon className="h-4 w-4" />
              <span>{t.label}</span>
            </DropdownMenuItem>
          ))}
          
          <DropdownMenuSeparator />
          
          <DropdownMenuLabel>Acessibilidade</DropdownMenuLabel>
          <DropdownMenuItem onClick={resetFontSize} className="flex items-center gap-2 cursor-pointer">
            <RotateCcw className="h-4 w-4" />
            <span>Resetar Tamanho de Fonte</span>
          </DropdownMenuItem>
          <div className="px-2 py-1.5 text-xs text-muted-foreground">
            Atalho: Alt + Shift + A (Alto Contraste)
          </div>
        </DropdownMenuContent>
      </DropdownMenu>
    </div>
  );
};